import BusinessImage from '@/assets/img/profile/styles/Business.png'
import CasualImage from '@/assets/img/profile/styles/Casual.png'
import BoldImage from '@/assets/img/profile/styles/Bold.png'
import SportChicImage from '@/assets/img/profile/styles/Sport chic.png'
import SexualImage from '@/assets/img/profile/styles/Sexual.png'
import CreativeImage from '@/assets/img/profile/styles/Creative.png'
import SmartCasualImage from '@/assets/img/profile/styles/Smart casual.png'
import RomanticImage from '@/assets/img/profile/styles/Romantic.png'
import HomeClothesImage from '@/assets/img/profile/styles/Home clothes.png'
import BeachwearImage from '@/assets/img/profile/styles/Beachwear.png'
import StylesIconsImage from '@/assets/img/profile/styles/Styles_icons.png'

/**
 * Маппинг значений стилей на изображения
 * Ключи соответствуют названиям файлов изображений (без расширения, в нижнем регистре)
 */
const styleImageMap: Record<string, string> = {
  // Маппинги для значений из API
  'business': BusinessImage,
  'casual': CasualImage,
  'edgy': BoldImage,
  'sporty': SportChicImage,
  // Маппинги по названиям файлов (с пробелами и с дефисами)
  'bold': BoldImage,
  'sport chic': SportChicImage,
  'sport-chic': SportChicImage,
  'sexual': SexualImage,
  'creative': CreativeImage,
  'smart casual': SmartCasualImage,
  'smart-casual': SmartCasualImage,
  'romantic': RomanticImage,
  'home clothes': HomeClothesImage,
  'home-clothes': HomeClothesImage,
  'beachwear': BeachwearImage,
  'styles_icons': StylesIconsImage,
  'styles-icons': StylesIconsImage
}

/**
 * Получение пути к изображению стиля
 * @param styleValue - значение стиля (например, 'business', 'casual', 'edgy', 'sporty')
 * @returns путь к изображению стиля
 */
export function getStyleImagePath(styleValue: string): string {
  return styleImageMap[styleValue] || StylesIconsImage
}


